// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: '4515380a-c52f-4f39-a4d3-4158249c2d90',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'de23f073-bd80-4e47-968a-def339e8eccb',
      type: 'Container',
      name: 'button',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4515380a-c52f-4f39-a4d3-4158249c2d90'
    },
    {
      id: '16129f70-64c6-488e-80af-5002c23af4c8',
      type: 'Container',
      name: 'newGameModeBubbleSlot',
      className: '',
      x: -72,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4515380a-c52f-4f39-a4d3-4158249c2d90'
    },
    {
      id: '8aac50c5-4ad3-45a2-bc6b-d34509c66ff4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_button_purple',
      parent: 'de23f073-bd80-4e47-968a-def339e8eccb'
    },
    {
      id: '0a061572-da1d-4fd4-af03-ebbcf49e6d30',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.2,
        y: 0.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_bolt',
      parent: 'de23f073-bd80-4e47-968a-def339e8eccb'
    },
    {
      id: 'b7fffe96-18b9-4b74-b4cc-41243ee670d8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_vs',
      parent: 'de23f073-bd80-4e47-968a-def339e8eccb'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  handleResize: false
} as const;

export class VersusMenuIconLayout {
  static raw = raw;
  root!: Container;
  button!: Container;
  newGameModeBubbleSlot!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
